export const securitySetup = {
  junior: {
    requirements: [
      { name: 'Content Privacy Training', description: 'Complete training on content privacy and data protection', priority: 'high' },
      { name: 'Brand Guidelines Compliance', description: 'Understand and follow brand security and compliance guidelines', priority: 'high' },
      { name: 'Secure Content Handling', description: 'Learn secure practices for handling sensitive content and user data', priority: 'medium' },
      { name: 'Tool Security Configuration', description: 'Secure configuration of content creation and collaboration tools', priority: 'medium' }
    ],
    procedures: [
      { step: 'Complete content privacy certification', command: 'Complete company content privacy and data protection training' },
      { step: 'Set up secure content storage', command: 'Configure secure cloud storage for content files with proper access controls' },
      { step: 'Enable 2FA on content tools', command: 'Enable two-factor authentication on all content creation platforms' },
      { step: 'Review content compliance procedures', command: 'Understand content approval workflows and compliance requirements' }
    ]
  },
  mid: {
    requirements: [
      { name: 'Content Governance', description: 'Implement content governance and approval processes', priority: 'high' },
      { name: 'Cross-platform Security', description: 'Ensure security across multiple content platforms and tools', priority: 'high' },
      { name: 'Content Audit Compliance', description: 'Conduct regular content audits for security and compliance', priority: 'medium' },
      { name: 'Vendor Security Assessment', description: 'Assess security of content tools and third-party platforms', priority: 'medium' }
    ],
    procedures: [
      { step: 'Implement content governance', command: 'Set up content governance framework with approval workflows' },
      { step: 'Conduct security assessments', command: 'Regular security assessment of content tools and processes' },
      { step: 'Set up content monitoring', command: 'Implement monitoring for content compliance and security' },
      { step: 'Create incident response plan', command: 'Develop incident response procedures for content security issues' }
    ]
  },
  senior: {
    requirements: [
      { name: 'Content Security Strategy', description: 'Define comprehensive security strategy for content operations', priority: 'high' },
      { name: 'Enterprise Content Governance', description: 'Establish enterprise-wide content governance and compliance', priority: 'high' },
      { name: 'Regulatory Compliance Framework', description: 'Ensure compliance with industry regulations for content', priority: 'high' },
      { name: 'Security Culture Development', description: 'Foster security-conscious culture within content teams', priority: 'medium' }
    ],
    procedures: [
      { step: 'Develop security framework', command: 'Create comprehensive security framework for content operations' },
      { step: 'Implement governance controls', command: 'Design and implement enterprise content governance controls' },
      { step: 'Establish compliance monitoring', command: 'Set up continuous compliance monitoring and reporting for content' },
      { step: 'Security awareness program', command: 'Develop security awareness and training program for content teams' }
    ]
  }
};
